<template>
    <div class="transaction-row" :class="{ 'transaction-row--active': isOpened }">
        <div
            @click="toggleDetails"
            class="d-flex align-items-center justify-content-between transaction-row__content"
        >
            <div class="transaction-row__information d-flex align-items-center">
                <div class="transaction-row__network-icon mr-2 mr-lg-4">
                    <div
                        class="rounded-circle d-flex align-items-center justify-content-center"
                        :style="{ backgroundColor:  transaction.accountColor }"
                    >
                        <span class="letter-icon">
                            {{ transaction.accountName | firstLettersLimit }}
                        </span>
                    </div>
                </div>
                <div class="flex-grow-1">
                    <p class="transaction-row__program-name mb-0 d-flex justify-content-between">
                        {{ transaction.program_name || 'Advertiser unknown' }}
                    </p>
                    <p class="transaction-row__date mb-0  w-100">
                        {{ transaction.date_transaction }}
                    </p>
                    <p class="transaction-row__domain mb-0 d-none d-lg-inline">
                        <b>Domain:</b> {{ transaction.website_domain }}
                    </p>
                </div>
            </div>
            <span class="d-flex align-items-center d-md-none transaction-row__mobile-price">
                <span :class=[getStatus] class="text-white transaction-row__badge d-inline mr-1" />
                {{ transformCurrency }}{{ transaction.amount | toDec }}
            </span>
            <div class="transaction-row__visitor-profile transaction-row-visitor-profile">
                <div
                    v-if="transaction.hasGAIntegration"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/sales-overview/google_analytics.svg"
                        alt="ga"
                    >
                </div>
                <div
                    v-if="transaction.hasBAIntegration"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/microsoft.svg"
                        alt="microsoft"
                    >
                </div>
                <div
                    v-if="transaction.hasKickbiteIntegration"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/kickbite-mini.svg"
                        alt="microsoft"
                    >
                </div>
            </div>
            <div class="transaction-row__additional-information transaction-row-additional-information">
                <div class="d-flex align-items-center justify-content-end justify-content-lg-between">
                    <div class="flex-grow-1 d-none d-lg-flex justify-content-center">
                        <div class="transaction-row-additional-information__subid">
                            <p
                                v-if="transaction.sub_id"
                                class="mb-0 font-weight-bold d-inline"
                            >
                                SUB ID
                            </p>
                            <p
                                :id="'subid' + transaction.id"
                                class="text-dark mb-0 transaction-row__subid-text d-block-inline"
                            >
                                {{ transaction.sub_id }}
                            </p>
                            <d-tooltip
                                :target="'#subid' + transaction.id"
                                placement="lefttop"
                                container=".transactions-group"
                            >
                                {{ transaction.sub_id }}
                            </d-tooltip>
                        </div>
                        <div class="transaction-row-additional-information__description">
                            <p
                                v-if="transaction.transaction_description"
                                class="mb-0 d-inline font-weight-bold"
                            >
                                DESCRIPTION
                            </p>
                            <p
                                :id="'description' + transaction.id"
                                class="text-dark mb-0 transaction-row__description-text"
                            >
                                {{ transaction.transaction_description }}
                            </p>
                            <d-tooltip
                                :target="'#description' + transaction.id"
                                placement="lefttop"
                                container=".transactions-group"
                            >
                                {{ transaction.transaction_description }}
                            </d-tooltip>
                        </div>
                        <div class="transaction-row-additional-information__status d-flex align-items-center justify-content-center">
                            <span :class=[getStatus] class="text-white transaction-row__badge">
                                <span class="d-none d-lg-inline">
                                    {{ transaction.internal_transaction_status.status_name }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="transaction-row-additional-information__amount d-none d-md-flex align-items-center">
                        <div>
                            <p class="mb-0 font-weight-bold">
                                AMOUNT
                            </p>
                            <p class="text-dark mb-0">
                                <span :class=[getStatus] class="text-white transaction-row__badge d-inline-block d-lg-none" />
                                {{ transformCurrency }}{{ transaction.amount | toDec }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="transaction-row__details-chevron">
                <span class="material-icons">
                    {{ isOpened ? 'expand_less' : 'expand_more' }}
                </span>
            </div>
        </div>
        <transition name="fade">
            <div v-if="isOpened">
                <d-card v-if="isLoading" class="d-flex flex-column align-items-center p-4">
                    <h5 class="mb-4">Loading details</h5>
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </d-card>
                <div v-else class="transaction-row__content transaction-row__content--scrollable" >
                <div>
                    <h5 class="mb-3 text-dark">
                        Details:
                    </h5>
                    <table class="table mb-0">
                        <tbody>
                        <tr>
                            <th>Page</th>
                            <th>SUB ID</th>
                            <th>Date</th>
                        </tr>
                        <tr v-for="session in reportDetails" :key="session.id">
                            <td v-if="session.document_path" class="collapse-td">
                                {{ session.hostname + session.document_path.replace(/%2F/gi, "/")}}
                            </td>
                            <td v-else class="collapse-td">
                                {{ session.hostname + '/'}}
                            </td>
                            <td class="collapse-td">
                                {{ session.sub_id }}
                            </td>
                            <td class="collapse-td">
                                {{ session.sub_id_generated_at }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Currencies from '@/models/currencies.model.js'
import TransactionStatus from '@/helpers/transactionStatus'
import { AnalysisService } from '@/main'

export default {
    props: {
        transaction: {
            required: true
        },
        currency: {
            required: true
        }
    },
    data() {
        return {
            isOpened: false,
            isLoading: false,
            reportDetails: [],
        }
    },
    methods: {
        toggleDetails() {
            this.isOpened = !this.isOpened
            if (!this.reportDetails.length) {
                this.getReportDetails()
            }
        },
        async getReportDetails() {
            this.isLoading = true
            try {
                const transactionsData = await AnalysisService.getFunnelReportItem(this.transaction.id);

                if (transactionsData.session.parent) {
                    this.reportDetails = transactionsData.session.parent.children
                    this.reportDetails.unshift(transactionsData.session.parent)
                } else {
                    this.reportDetails[0] = transactionsData.session
                }

                this.isLoading = false
            } catch(e) {
                console.error(e)
            }
        },
    },
    computed: {
        transformCurrency() {
           return Currencies[this.currency]
        },
        getStatus() {
            return TransactionStatus.getStatusClass(this.transaction.internal_transaction_status.status_name)
        },
    }
}
</script>
